module.exports = __webpack_public_path__ + "static/media/worldmap.60a56df0.png";